import { render, staticRenderFns } from "./gatewayResponse.vue?vue&type=template&id=367d8438&scoped=true&"
import script from "./gatewayResponse.vue?vue&type=script&lang=js&"
export * from "./gatewayResponse.vue?vue&type=script&lang=js&"
import style0 from "./gatewayResponse.vue?vue&type=style&index=0&id=367d8438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367d8438",
  null
  
)

export default component.exports